import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
const Creator = lazy(() => import("@/components/creator/Creator"));
const ErrorPage = lazy(() => import("@/components/ErrorPage/ErrorPage"));

const App: React.FC = () => {
  return (
    <Suspense>
      <Routes>
        <Route path="/*" element={<Creator />} />
        <Route
          path="/error"
          element={
            <ErrorPage
              type="runtime"
              title="An error occurred"
              message="Something went wrong. Please try again or contact support."
              errors={[]}
            />
          }
        />
      </Routes>
    </Suspense>
  );
};

export default App;
